import { useEffect, useState } from "react";
import type { Dayjs } from "dayjs";
import dayjs from "dayjs";
import type { UseStepPeriodProps } from "../types/hooks";

const useStepPeriod = ({ activeStep }: UseStepPeriodProps) => {
  const [range, setRange] = useState<[Dayjs | null, Dayjs | null]>([
    null,
    null,
  ]);

  const initializeRange = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const startDateParam = queryParams.get("start_date");
    const endDateParam = queryParams.get("end_date");

    if (startDateParam && endDateParam) {
      setRange([dayjs(startDateParam), dayjs(endDateParam)]);
    }
  };

  useEffect(() => {
    if (activeStep === 1) {
      // Initialize or fetch any data needed for this step
      initializeRange();
    }
  }, [activeStep]);

  return { range, setRange };
};

export { useStepPeriod };
